import React, { useRef } from "react";

const ThreeDHover = ({
  children,
  className = "",
  intensity = 100,
  scale = 1.02,
  onClick,
}) => {
  const containerRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    containerRef.current.style.transform = `
      perspective(1000px)
      rotateX(${(y - 0.5) * intensity}deg)
      rotateY(${(x - 0.5) * intensity}deg)
      scale(${scale})
    `;
  };

  const handleMouseLeave = () => {
    containerRef.current.style.transform = `
      perspective(1000px)
      rotateX(0deg)
      rotateY(0deg)
      scale(1)
    `;
  };

  return (
    <div
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      className={`transform-style-3d ${className}`}
      style={{
        transformStyle: "preserve-3d",
        transition: "transform 0.1s ease-out, box-shadow 0.1s ease-out",
      }}
    >
      {children}
    </div>
  );
};

export default ThreeDHover;
